/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { GmpHandler, GmpHandlerInterface } from "../GmpHandler";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "actual",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expected",
        type: "uint256",
      },
    ],
    name: "UnexpectedValue",
    type: "error",
  },
  {
    inputs: [],
    name: "MAX_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "args",
        type: "bytes",
      },
    ],
    name: "setResource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "executeProposal",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type GmpHandlerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GmpHandlerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GmpHandler__factory extends ContractFactory {
  constructor(...args: GmpHandlerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "GmpHandler";
  }

  deploy(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GmpHandler> {
    return super.deploy(bridgeAddress, overrides || {}) as Promise<GmpHandler>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(bridgeAddress, overrides || {});
  }
  attach(address: string): GmpHandler {
    return super.attach(address) as GmpHandler;
  }
  connect(signer: Signer): GmpHandler__factory {
    return super.connect(signer) as GmpHandler__factory;
  }
  static readonly contractName: "GmpHandler";
  public readonly contractName: "GmpHandler";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GmpHandlerInterface {
    return new utils.Interface(_abi) as GmpHandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GmpHandler {
    return new Contract(address, _abi, signerOrProvider) as GmpHandler;
  }
}
